import { FC } from 'react';

import CableIcon from '@mui/icons-material/Cable';
import ToolCard from 'components/ToolCard';
import Button from '@mui/material/Button';

const IntegrationsCard: FC = () => (
  <ToolCard
    icon={<CableIcon fontSize="large" />}
    title="Sąsajos"
    description="Čia rasite sąsajų su išorinėmis sistemomis nustatymus"
    action={
      <Button href="integrations" startIcon={<CableIcon />} size="small">
        Žiūrėti
      </Button>
    }
  />
);

export default IntegrationsCard;
